import SeoHead from "@/Component/Seo/SeoHead";
import AuthorProfile from "@/Component/AuthorProfile";
import { serverFetchBlogsByAuthor } from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { fetchAuthorBlogListPages } from "@/utils/blogHelpers";
import { renderNotFoundPage } from "@/utils/detailSlug";
import { fetchPageSeo } from "@/utils/pageSeo";

const AUTHOR_PAGE_SIZE = 12;

export default function AuthorProfilePage({
  seo,
  seoCountry,
  slug,
  authorProfile,
  initialArticleList,
  initialArticleMeta,
  country,
}) {
  const fallbackTitle = authorProfile?.name
    ? `Author Profile - ${authorProfile.name} | Next Holidays`
    : "Author Profile | Next Holidays";

  return (
    <>
      <SeoHead seo={seo} country={seoCountry} fallbackTitle={fallbackTitle} />
      <AuthorProfile
        authorSlug={slug}
        authorProfile={authorProfile}
        initialArticleList={initialArticleList}
        initialArticleMeta={initialArticleMeta}
        country={country}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  const country = getCountryFromContext(context);
  const seoResult = await fetchPageSeo(context);
  if (seoResult.redirect) return seoResult;

  const slug = String(context.params?.slug || "").trim();
  const page = Math.max(1, parseInt(context.query.page || "1", 10) || 1);

  if (!slug) {
    return renderNotFoundPage(context);
  }

  try {
    const authorData = await fetchAuthorBlogListPages(
      { authorSlug: slug, pageSize: AUTHOR_PAGE_SIZE, page },
      (payload) => serverFetchBlogsByAuthor(payload, country)
    );

    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        slug,
        authorProfile: authorData.author,
        initialArticleList: authorData.items,
        initialArticleMeta: {
          totalCount: authorData.totalCount,
          pageIndex: authorData.pageIndex,
          totalPages: authorData.totalPages,
          pageSize: authorData.pageSize,
        },
        country,
      },
    };
  } catch (error) {
    console.error("Author profile SSR error:", error);
    return renderNotFoundPage(context);
  }
}
